import { TTextsOverride } from '@digital-dealer/texts-service';

const textsOverride: TTextsOverride = {
  retail: {
    modules: {
      modelViewer: {
        checkout: {
          bankLoanCalculator: {
            buttonTitle: 'Beräkna ditt billån',
            title: 'Beräkna ditt billån',
            monthlyPayment: 'Din månadskostnad',
            rules: {
              title: 'Finansiering via Jyske Finans',
              insurancePaymentRequired: 'Försäkring och betalning via Nets krävs',
              creditApprovalRequired: 'Kreditgodkännande krävs',
              cancellationRight: 'Det är 14 dagars ångerrätt på lånet',
              reservations: 'Vi reserverar oss för felskrivningar, pris- och produktändringar',
              standAlone: 'Kampanjen kan inte kombineras med övriga erbjudanden',
            },
            min: 'min',
            desiredDownPayment: 'Din önskade handpenning',
            desiredLoanTerm: 'Din önskade avtalstid på lånet',
            overview: {
              price: 'Pris',
              loanAmount: 'Lånebelopp',
              debtorInterest: 'Debitor ränta',
              annualPercentageRate: 'Åop',
              totalCreditConversion: 'Samlade kreditomk.',
              repaidInTotal: 'Totalt återbetalat',
              somethingWentWrong: 'Något gick snett. Testa att ladda om sidan eller gå vidare, så ringer vi tillbaka.',
            },
          },
          bankLoanMockCalculator: {
            buttonTitle: 'Beräkna ditt billån',
            title: 'Beräkna ditt billån',
            monthlyPayment: 'Månadskostnad',
            downpaymentLabel: 'Kontantinsats',
            downpaymentLabelVan: 'Första förhöjd hyra',
            legalText: {
              title: 'Villkor och information',
            },
            overview: {
              carPrice: 'Bilens pris',
              interestRate: 'Ränta (%)',
              duration: 'Avbetalningsperiod',
              residualValueRate: 'Beräknat restvärde',
              setupFee: 'Uppläggningsavgift',
              billFee: 'Aviavgift',
              effectiveInterestRate: 'Effektiv ränta',
              residualValue: 'Restvärde',
              loanAmount: 'Kreditbelopp',
              somethingWentWrong: 'Något gick snett. Testa att ladda om sidan eller gå vidare, så ringer vi tillbaka.',
            },
            units: {
              months: 'mån',
              perMonth: 'kr/mån',
              percent: '%',
              checkmark: '✓',
            },
          },
        },
      },
    },
  },
};

export default textsOverride;

